import type { InferValueTypes } from '@r1-frontend/shared/types/Redux';

import * as actions from '../actions';
import { EActions } from '../constants/actions';

import { TInitialState } from './initialState';

export type TAction = ReturnType<InferValueTypes<typeof actions>>

const reducer = (debugMode = false): (state: TInitialState, action: TAction) => TInitialState =>
    (state: TInitialState, action: TAction): TInitialState => {
        if (debugMode) {
            console.log(action);
            console.table(state);
        }
        switch (action.type) {
            case EActions.initialization: {
                return {
                    ...state,
                    salePackageId: action.payload.salePackageId,
                    withReissue: action.payload.withReissue,
                };
            }
            case EActions.initialized: {
                return {
                    ...state,
                    initialized: true,
                };
            }
            case EActions.setAddress: {
                return {
                    ...state,
                    address: action.payload.address,
                    suggestionSelected: false,
                };
            }
            case EActions.selectAddressFromList: {
                return {
                    ...state,
                    suggestionSelected: true,
                    hasError: action.payload.hasError,
                };
            }
            case EActions.startChecking: {
                return {
                    ...state,
                    isLoading: true,
                };
            }
            case EActions.checkingFinish: {
                return {
                    ...state,
                    isLoading: false,
                    checkResult: action.payload.checkResult,
                };
            }
            case EActions.flush: {
                return {
                    ...state,
                    address: '',
                    checkResult: null,
                };
            }
            default: {
                return { ...state };
            }
        }
    };

export default reducer;
